module.exports = __webpack_public_path__ + "static/InteriorLandingHeroLiving-55cb04a0d6e4e7f71767fb174917c7d5.jpg";